import { createSvgIcon } from '@mui/material';

interface PropTypes {
  filled?: boolean;
}

const AnnouncementsIcon = (props: PropTypes) => {
  const { filled } = props;

  const IconCmp = createSvgIcon(
    <>
      <path
        d="M2.78432 13.0842C1.6448 12.1599 0.916505 10.7483 0.916504 9.16672C0.916504 6.38228 3.17373 4.12505 5.95817 4.12505H9.39567C11.0462 4.12505 12.7027 3.28945 14.1167 2.51858C14.5354 2.29035 14.895 2.09427 15.1862 1.9629C15.4542 1.84197 15.8445 1.68621 16.2644 1.73763C16.7899 1.80199 17.2246 2.06012 17.5326 2.49069C17.7746 2.82895 17.8276 3.23029 17.8506 3.51971C17.8934 4.05892 17.8748 4.60334 17.8748 5.14394C19.7118 5.56078 21.0832 7.20361 21.0832 9.16673C21.0832 11.1298 19.7118 12.7727 17.8748 13.1895C17.8748 13.7301 17.8934 14.2745 17.8506 14.8137C17.8276 15.1031 17.7746 15.5045 17.5326 15.8427C17.2246 16.2733 16.7899 16.5314 16.2644 16.5958C15.8445 16.6472 15.4542 16.4915 15.1862 16.3705C14.8092 16.2004 14.4479 15.9954 14.085 15.7976C12.8073 15.101 11.3325 14.4536 10.0832 14.2641C10.0832 15.693 10.2084 17.1754 10.0703 18.5989C9.94337 19.9078 8.90753 20.9436 7.59864 21.0705C7.30782 21.0988 6.9983 21.0981 6.70708 21.0742C5.61395 20.9848 4.67847 20.2544 4.32661 19.2156C4.29023 19.1082 4.26122 18.992 4.22779 18.8581L2.78432 13.0842ZM17.8748 11.2677C18.6842 10.9141 19.2498 10.1065 19.2498 9.16673C19.2498 8.227 18.6842 7.41938 17.8748 7.06575V11.2677Z"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'AnnouncementsIcon',
  );

  const FilledIconCmp = createSvgIcon(
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.78432 13.0842C1.6448 12.1599 0.916505 10.7483 0.916504 9.16672C0.916504 6.38228 3.17373 4.12505 5.95817 4.12505H9.39567C11.0462 4.12505 12.7027 3.28945 14.1167 2.51858C14.5354 2.29035 14.895 2.09427 15.1862 1.9629C15.4542 1.84197 15.8445 1.68621 16.2644 1.73763C16.7899 1.80199 17.2246 2.06012 17.5326 2.49069C17.7746 2.82895 17.8276 3.23029 17.8506 3.51971C17.8934 4.05892 17.8748 4.60334 17.8748 5.14394C19.7118 5.56078 21.0832 7.20361 21.0832 9.16673C21.0832 11.1298 19.7118 12.7727 17.8748 13.1895C17.8748 13.7301 17.8934 14.2745 17.8506 14.8137C17.8276 15.1031 17.7746 15.5045 17.5326 15.8427C17.2246 16.2733 16.7899 16.5314 16.2644 16.5958C15.8445 16.6472 15.4542 16.4915 15.1862 16.3705C14.8092 16.2004 14.4479 15.9954 14.085 15.7976C12.8073 15.101 11.3325 14.4536 10.0832 14.2641C10.0832 15.693 10.2084 17.1754 10.0703 18.5989C9.94337 19.9078 8.90753 20.9436 7.59864 21.0705C7.30782 21.0988 6.9983 21.0981 6.70708 21.0742C5.61395 20.9848 4.67847 20.2544 4.32661 19.2156C4.29023 19.1082 4.26122 18.992 4.22779 18.8581L2.78432 13.0842ZM17.8748 11.2677C18.6842 10.9141 19.2498 10.1065 19.2498 9.16673C19.2498 8.227 18.6842 7.41938 17.8748 7.06575V11.2677Z"
        fill="#4E48FA"
      />
    </>,
    'AnnouncementsIcon',
  );

  return filled ? (
    <FilledIconCmp style={{ fill: 'none' }} viewBox={'0 0 22 22'} />
  ) : (
    <IconCmp style={{ fill: 'none' }} viewBox={'0 0 22 22'} />
  );
};

export default AnnouncementsIcon;
